import { useApp } from "@/contexts/AppContext";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

function generateYears() {
  const cur = new Date().getFullYear();
  const years = [];
  for (let y = cur - 2; y <= cur + 2; y++) years.push(`${y}/${y + 1}`);
  return years;
}

export default function ContextSelector() {
  const { ctx, setContext, meta } = useApp();
  const stages = meta?.stages || [];
  const years = generateYears();

  return (
    <div className="flex items-center gap-1.5" data-testid="context-selector">
      <Select value={ctx.stage} onValueChange={(v) => setContext({ stage: v })}>
        <SelectTrigger
          className="w-[180px] h-9 text-[12.5px] bg-white border-[#E4E9E5] hover:border-[#0E7C6F]/30 rounded-lg"
          data-testid="stage-select"
        >
          <SelectValue placeholder="المرحلة" />
        </SelectTrigger>
        <SelectContent>
          {stages.map((s) => (
            <SelectItem key={s} value={s} data-testid={`stage-opt-${s}`}>{s}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select value={ctx.year} onValueChange={(v) => setContext({ year: v })}>
        <SelectTrigger
          className="w-[128px] h-9 text-[12.5px] bg-white border-[#E4E9E5] hover:border-[#0E7C6F]/30 rounded-lg"
          data-testid="year-select"
        >
          <SelectValue placeholder="العام" />
        </SelectTrigger>
        <SelectContent>
          {years.map((y) => (
            <SelectItem key={y} value={y}>{y}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select
        value={String(ctx.semester)}
        onValueChange={(v) => setContext({ semester: v === "end_year" ? "end_year" : Number(v) })}
      >
        <SelectTrigger
          className="w-[140px] h-9 text-[12.5px] bg-white border-[#E4E9E5] hover:border-[#0E7C6F]/30 rounded-lg"
          data-testid="semester-select"
        >
          <SelectValue placeholder="الفصل" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="1">الفصل الأول</SelectItem>
          <SelectItem value="2">الفصل الثاني</SelectItem>
          <SelectItem value="end_year">نهاية العام</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
